import React,{useState} from "react";
import styles from "./DashboardProfile.module.css";

import { CgMenu } from "react-icons/cg";
import { useEffect } from "react";

const DashboardLeads = (props) => {
  const [data, setData] = useState('')
  const url = process.env.REACT_APP_URL;
  const fetchData=()=>{
    // let api = url + "/leads";
    let api = "http://localhost:8080" + "/leads";
    fetch(api).then(res=>res.json()).then(data=>setData(data.data));
  }
  useEffect(()=>{
    fetchData();
  })
  return (
    <>
      <div className={styles["NewDashboard-Body__container"]}>
        <div className={styles["NewDashboard-header"]}>
          <CgMenu
            className={styles["menu-btn"]}
            onClick={() => props.menuDisplayHandler(true)}
          />
          <h1 className={styles["dashboard-heading"]}>View all Vendor Leads</h1>
        </div>
        <div className={styles["NewDashboard-booking__route"]}>
          <h5>Vendor Leads</h5>
        </div>
        <div class="mt-5">
          <div class="rounded">
            <div
              class="table-responsive"
              style={{ height: "550px", overflow: "scroll" }}
            >
              <table class="table">
                <thead className={styles["thead"]}>
                  <tr class="bg-red">
                    <th>Name</th>
                    <th>Number</th>
                    <th>Email</th>
                    <th>Message</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className={styles["table-body"]}>
                  { data != ''
                  ? data.map((item) => {
                    return (
                      <tr className={styles["cell-1"]}>
                        <td>{item.name}</td>
                        <td>{item.phone}</td>
                        <td>{item.email}</td>
                        <td>{item.service}</td>
                        <td>{item.date}</td>
                        <td>{item.time}</td>
                        {item.status ? (
                          <td>
                            <span class="badge badge-danger">Pending</span>
                          </td>
                        ) : (
                          <td>
                            <span class="badge badge-success">Confirmed</span>
                          </td>
                        )}
                      </tr>
                    );
                  })
                  : <tr className={styles["cell-1"]}>
                        <td colSpan="7" >No bookings available.</td>
                      </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardLeads;
